import * as cookie from 'js-cookie';
import session from 'lib/session';
import React from 'react';
import { Redirect } from 'react-router';

export default ({ match }) => {
  cookie.remove(session.KC_TOKEN_KEY);
  session.token = match.params.token;
  if (match.params.merchant) {
    session.merchant = match.params.merchant;
  }
  let url = '/';
  if (window.location.search.includes('onboardingId')) {
    const onboardingId = window.location.search
      .split('onboardingId=')[1]
      .split('&')[0];
    url = `/onboarding?onboardingId=${onboardingId}`;
  }
  return React.createElement(Redirect, {
    to: url,
  });
};
